module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldCondIt.d1f7a6c.eot";